import React from "react";
import TablaProductos from "../../components/productos/TablaProductos";

const ProductosSection = () => {
  return (
    <div>
      <TablaProductos />
    </div>
  );
};

export default ProductosSection;
